import React, { ComponentProps } from 'react';
import { ImageTypes, ContentImage } from '../../../types/api/ImageType';
import { useBlockContext, useRefreshBlock } from '../../../_lib/BlockFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';

import { asFetchableView } from '../../../_lib/ViewFetcher';
import { ImageUploadForm } from '../../../_lib/components/ImageUpload/ImageUploadForm';
import { CheckBoxParam, HiddenParam, RadioParam, SonForm, TextParam } from '../../../_lib/Form2';
import { NestedParam } from '../../../_lib/Form2/types/NestedParam';
import { ImageFileParam } from '../../../_lib/Form2/types/FileUploadParam';

type ContentImageEditProps = {
  image: ContentImage;
  cropping: boolean;
  viewportSwitch: boolean;
  form: SonForm<
    NestedParam<
      'imageuploadparams',
      'imageupload',
      | ImageFileParam<'image'>
      | HiddenParam<'width'>
      | HiddenParam<'height'>
      | HiddenParam<'y'>
      | HiddenParam<'x'>
      | TextParam<'alt'>
      | TextParam<'copyright'>
      | TextParam<'caption'>
      | CheckBoxParam<'popUp'>
      | RadioParam<'size', 'large' | 'medium' | 'small'>
    >
  >;
};

export function ContentImageEdit({ image, form, cropping, viewportSwitch }: ContentImageEditProps) {
  const { uuid } = useBlockContext();
  const { refresh } = useRefreshBlock();
  const { t } = useSonTranslation('ContentImage');

  return (
    <ImageUploadForm
      imageDescriptionName={t('imageDescriptionName')}
      responsiveType="contentImage"
      imageType={ImageTypes.contentImage}
      cropping={cropping}
      viewportSwitch={viewportSwitch}
      form={form}
      formId="content-image-upload-form"
      uuid={uuid}
      initialImage={image}
      refresh={refresh}
    />
  );
}

export const ContentImageEditView = asFetchableView(ContentImageEdit);
export type ContentImageEditView = ComponentProps<typeof ContentImageEditView>;
